export default __webpack_public_path__ + "static/media/normal-face.49ca17a5.svg";